/* eslint-disable no-unused-vars */
// needed since color isn't used in the template but appears in the replaced body
import React from "react";
import PropTypes from "prop-types";

/*
 * Yuka v2.0
 * This component corresponds to ``face-sad.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */
const FaceSadIcon = ({ color, size }) => (
  <svg width={size} height={size} viewBox="0 0 18 18">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        fill={color}
        fillRule="evenodd"
        d="M9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9ZM7.97362 6.34846C8.29479 6.61004 8.34311 7.08245 8.08154 7.40362C7.66142 7.91945 7.05213 8.25 6.375 8.25C5.69035 8.25 5.0991 7.91322 4.67724 7.41419C4.40982 7.09786 4.44948 6.62465 4.76581 6.35723C5.08214 6.08982 5.55535 6.12948 5.82276 6.44581C6.0159 6.67428 6.21215 6.75 6.375 6.75C6.54536 6.75 6.74608 6.66804 6.91846 6.45638C7.18004 6.1352 7.65245 6.08689 7.97362 6.34846ZM13.2236 6.34846C13.5448 6.61004 13.5931 7.08245 13.3315 7.40362C12.9114 7.91945 12.3021 8.25 11.625 8.25C10.9404 8.25 10.3491 7.91322 9.92724 7.41419C9.65982 7.09786 9.69948 6.62465 10.0158 6.35723C10.3321 6.08982 10.8054 6.12948 11.0728 6.44581C11.2659 6.67428 11.4621 6.75 11.625 6.75C11.7954 6.75 11.9961 6.66804 12.1685 6.45638C12.43 6.1352 12.9024 6.08689 13.2236 6.34846ZM6.35575 10.6434C6.9542 10.2082 7.85585 9.75 9 9.75C10.1441 9.75 11.0458 10.2082 11.6443 10.6434C11.9449 10.8621 12.1774 11.0807 12.3364 11.2467C12.4163 11.33 12.4785 11.401 12.5225 11.4534C12.5445 11.4796 12.562 11.5013 12.5749 11.5176L12.5909 11.5381L12.5963 11.5451L12.5984 11.5478L12.5992 11.549C12.5994 11.5492 12.6 11.55 12 12L12.6 11.55C12.8485 11.8814 12.7814 12.3515 12.45 12.6C12.1197 12.8477 11.6515 12.7818 11.4024 12.4531L11.3989 12.4487C11.3944 12.443 11.3859 12.4325 11.3735 12.4177C11.3487 12.3881 11.3084 12.3419 11.2534 12.2846C11.143 12.1693 10.9769 12.0129 10.762 11.8566C10.3292 11.5418 9.73085 11.25 9 11.25C8.26915 11.25 7.6708 11.5418 7.238 11.8566C7.02305 12.0129 6.85704 12.1693 6.74657 12.2846C6.69164 12.3419 6.65135 12.3881 6.62648 12.4177C6.61408 12.4325 6.60559 12.443 6.60113 12.4487L6.59797 12.4527L6.59879 12.4516L6.59935 12.4509M6.59935 12.4509C6.59868 12.4518 6.59864 12.4518 6.59797 12.4527C6.34883 12.7814 5.88033 12.8477 5.55 12.6C5.21863 12.3515 5.15147 11.8814 5.4 11.55L6 12C5.4 11.55 5.39982 11.5502 5.4 11.55L5.40162 11.5478L5.40368 11.5451L5.40908 11.5381L5.42506 11.5176C5.43799 11.5013 5.4555 11.4796 5.47752 11.4534C5.5215 11.401 5.58375 11.33 5.66359 11.2467C5.82264 11.0807 6.05507 10.8621 6.35575 10.6434"
        transform=""
      />
    </g>
  </svg>
);

FaceSadIcon.propTypes = {
  // all of these can be overriden in CSS as necessary
  color: PropTypes.string,
  size: PropTypes.number,
};

FaceSadIcon.defaultProps = {
  color: "#ffffff",
  size: 16,
};

FaceSadIcon.displayName = "FaceSadIcon";

export default FaceSadIcon;
